import { usePageDragAndDrop } from "@/components/drag-and-drop/dnd-provider";
import { ImportDropTarget } from "@/components/importing";
import { EventContext } from "@/domains/metrics/context";
import { importDroppedItems } from "@/modules/importing/drop-and-drop-markdown";
import { useAppStore } from "@/store";
import styled from "@emotion/styled";
import { useCallback, useState } from "react";
import { DropItem } from "react-aria-components";

interface Props {
  onDrop: (items: DropItem[]) => boolean | void;
}

export const DropTargetStep: React.FC<Props> = ({ onDrop }) => {
  const { store } = useAppStore();
  const [isDragOver, setIsDragOver] = useState(false);

  const handleDrop = useCallback(
    (e: { items: DropItem[] }) => {
      setIsDragOver(false);
      const isBlocked = onDrop(e.items) === false; // if onDrop callback returns anything except false, then we continue
      if (!isBlocked) {
        importDroppedItems(e.items, store, EventContext.GlobalActions);
      }
    },
    [store, onDrop]
  );

  const handleDropEnter = useCallback(() => {
    setIsDragOver(true);
  }, []);

  const handleDropExit = useCallback(() => {
    setIsDragOver(false);
  }, []);

  usePageDragAndDrop({
    priority: 10,
    isActive: true, // Always active when this step is visible
    onDrop: handleDrop,
    onDropEnter: handleDropEnter,
    onDropExit: handleDropExit,
  });

  return (
    <Wrapper>
      <ImportDropTarget isActive={isDragOver} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding-top: ${({ theme }) => theme.spacing.lg};
  padding-bottom: ${({ theme }) => theme.spacing.lg};
  margin-bottom: 20px;
  background-color: ${({ theme }) => theme.colors.grey.x25};
  border-radius: ${({ theme }) => theme.borderRadius.large + "px"};
`;
